import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LoadingWithCountdown = () => {
  const [countdown, setCountdown] = useState(10);
  const [visible, setVisible] = useState(true);
  const {t} = useTranslation()

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      setVisible(false);
    }
  }, [countdown]);

  if (!visible) return null;

return (
    <div className="overlay">
        <div className="card">
            <h2 className="title">{t("testWait")}</h2>
            <p className="subtitle">{t("testwaiting")}</p>
            <div className="countdownCircle">
                <svg width="100" height="100">
                    <circle
                        cx="50"
                        cy="50"
                        r="45"
                        stroke="#eee"
                        strokeWidth="10"
                        fill="none"
                    />
                    <circle
                        cx="50"
                        cy="50"
                        r="45"
                        stroke="#4facfe"
                        strokeWidth="10"
                        fill="none"
                        strokeDasharray="283"
                        strokeDashoffset={283 - (countdown / 10) * 283}
                        strokeLinecap="round"
                        transform="rotate(-90 50 50)"
                        style={{ transition: 'stroke-dashoffset 1s linear' }}
                    />
                    <text
                        x="50"
                        y="55"
                        textAnchor="middle"
                        fontSize="24"
                        fill="#333"
                        fontWeight="bold"
                    >
                        {countdown}
                    </text>
                </svg>
            </div>
        </div>
    </div>
);
};


export default LoadingWithCountdown;
